export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.loader', {
      url: 'loader',
      template: '<nets-loader></nets-loader>',
    });
};
